if (typeof BSS_B2B != undefined) {
  setTimeout(() => {
    const inputQuantity = document.querySelector("quantity-selector");
    if (inputQuantity) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        const notifyMessage1 = document.getElementById('olNotifyMessageBSS');
        const notifyMessage2 = document.getElementById('qiNotifyMessageBSS');
        const button = document.querySelector('.product__info-container .product-form--atc-button');

        if (button) {
          if (notifyMessage1) {
            button.insertAdjacentElement('afterend', notifyMessage1);
          }
          if (notifyMessage2) {
            button.insertAdjacentElement('afterend', notifyMessage2);
          }
        }
      });
      mutationObserver.observe(inputQuantity, { childList: true, subtree: true });
    }
  }, 2000);

  setTimeout(() => {
    if (window.location.pathname.includes("/products")) {
      const inputQuantity = document.querySelector("quantity-selector");
      if (inputQuantity) {
        const notifyMessage1 = document.getElementById('olNotifyMessageBSS');
        const notifyMessage2 = document.getElementById('qiNotifyMessageBSS');
        const button = document.querySelector('.product__info-container .product-form--atc-button');

        if (button) {
          if (notifyMessage1) {
            button.insertAdjacentElement('afterend', notifyMessage1);
          }
          if (notifyMessage2) {
            button.insertAdjacentElement('afterend', notifyMessage2);
          }
        }
      }
    }
  }, 2000);

  setTimeout(() =>{
    let quickViewBtn = document.querySelectorAll('.quickshop-button');
    if (quickViewBtn.length) {
        for (let i = 0; i < quickViewBtn.length; i++) {
            quickViewBtn[i].onclick = function () {
                setTimeout(function () {
                  document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"))    
                }, 2000);
            }
        }
    }
  }, 3000)
}

// if (location.pathname.includes("/cart")) {
//   document.addEventListener("DOMContentLoaded", function () {
//     const value = BSS_BCP.nt.translation.find((item) => item.key === "purchase_late_note")?.value;

//     if (value) {
//       document.querySelectorAll(".bss-purchase-late-rule-name").forEach(function (element) {
//         element.innerHTML = value;
//       });
//     }
//   })
// }
